<template>
  <svg
    width="30"
    height="28"
    viewBox="0 0 30 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.8932 13.12L26.4132 10.28L26.7598 6.52002C26.8265 5.85336 26.3732 5.24002 25.7332 5.09336L22.0532 4.26669L20.1332 1.01336C19.7865 0.440022 19.0799 0.200022
    18.4532 0.466689L14.9999 1.94669L11.5465 0.466689C10.9332 0.200022 10.2132 0.440022 9.87985 1.01336L7.94652 4.25336L4.27985 5.08002C3.62652 5.22669 3.17318 5.82669 3.23985
    6.49336L3.58652 10.2667L1.09318 13.12C0.653184 13.6267 0.653184 14.3734 1.09318 14.88L3.58652 17.72L3.23985 21.4934C3.17318 22.16 3.62652 22.7734 4.26652 22.92L7.94652
    23.76L9.86652 27C10.2132 27.5734 10.9332 27.8134 11.5465 27.5467L14.9999 26.04L18.4532 27.52C19.0665 27.7867 19.7865 27.5467 20.1199 26.9734L22.0399 23.7334L25.7199 22.8934C26.3732
    22.7467 26.8132 22.1334 26.7465 21.4667L26.3998 17.7067L28.8799 14.8667C29.3332 14.3734 29.3332 13.6267 28.8932 13.12ZM12.6398 17.7734L9.81318 14.9467C9.29318 14.4267 9.29318 13.5867
    9.81318 13.0667C10.3332 12.5467 11.1732 12.5467 11.6932 13.0667L13.5732 14.9467L18.2932 10.2267C18.8132 9.70669 19.6532 9.70669 20.1732 10.2267C20.6932 10.7467 20.6932 11.5867 20.1732
    12.1067L14.5199 17.76C14.0132 18.2934 13.1599 18.2934 12.6398 17.7734Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Verified'
  }
</script>
